module.exports = __webpack_public_path__ + "media/images/google-play-icon-4961c5c3a851c7106a9d020cc1e8f7eb.png";